import { TGuildDetailsClientState } from '../libs/store';
import { TAction } from './types/action';

// Action Types
export const GET_GUILD_DETAILS = 'GET_GUILD_DETAILS';

export type TGetGuildDetailsAction = TAction<TGuildDetailsClientState>;

// Action Creators
export function createActionGetGuildDetails(payload: TGuildDetailsClientState): TGetGuildDetailsAction {
  return {
    payload,
    type: GET_GUILD_DETAILS
  };
}
